(($) => {

	let $widgets;

	$(document).on('ready', init);

	function init() {
		$widgets = $('.widget');

        $widgets.each(function() {
            let $widget = $(this);
            $widget.children('.js-widget-title').attr('id', $widget.attr('id') + '-title');
        });
	}
})(jQuery);